export const blockIconsTransportationTireRepairNew = (
	<span className='material-symbols-outlined'>tire_repair</span>
);
